const Builder = require('../BuilderBase');

module.exports = class Toggle extends Builder {
    constructor(title, properties) {
        super('actionElement_Toggle', title, properties);
    }
};
